<template>
    <div class="help-center-content">
        <h4>有声播讲 技巧</h4>
        <p class="title">1.  如何咬字发音更清晰？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10128743/" target="_blank">【播音入门】让你远离咬字不清的烦恼（张熙棠）</a></p>
        <p class="title">2.  如何掌握用气发声？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10224229/" target="_blank">【播音入门】让你掌握用气发声秘籍（张熙棠）</a></p>
        <p class="title">3.  如何突破方言普通话瓶颈？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10291170/" target="_blank">【播音入门】练好嘴皮子，从正确读绕口令开始（卡恩老师）</a></p>
        <p class="title">4.  如何变读为说？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10386858/" target="_blank">【播音入门】“推倒”自己心仪的有声书，有声播讲从“读”变“说”开始（全勇老师）</a></p>
        <p class="title">5.  如何讲好旁白？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10420739/" target="_blank">【有声入门】有声播讲的旁白技法（全勇老师）</a></p>
        <p class="title">6.  如何扮演角色？</p>
        <p class="content"><a href="http://www.ximalaya.com/16370997/sound/10577304/" target="_blank">【播音入门】有声播讲的台词技巧，精准塑造人物形象（全勇老师）</a></p>
        <p class="title">7.  如何防止喷麦？</p>
        <p class="content">防止受到呼吸声，自然环境声音的干扰。建议使用耳机录制，并且在耳机麦克风上盖上一层湿纸巾即可。起到麦克风保护套的作用，这样即可防止带来外界的干扰。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// AnnounceTips.vue?589dfb1b